import { ButtonModule } from 'primeng/button';
import { AfterViewInit, Component } from '@angular/core';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { LoaderComponent } from "../../../utils/loader/loader.component";
import { CustomTableComponent } from "../../../utils/custom-table/custom-table.component";
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-balance',
    imports: [ButtonModule, FormsModule, LoaderComponent, CustomTableComponent, SelectModule],
    templateUrl: './balance.component.html',
    styleUrl: './balance.component.scss'
})
export class BalanceComponent implements AfterViewInit {
  consumptions: any[] = [];
  loading = false;
  reporterURL = environment.wrUrl;
  fromDateRequest!: Date;
  MONTH_NAMES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  data: any;
  selectedMonth = 0;
  today = new Date();
  selectedYear = this.today.getFullYear();
  constructor(private service: ReportsServicesService, private titleService: Title, private themeService: ThemeService

  ) {
    this.titleService.setTitle("Reporte - Balance");
    this.themeService.setTitle("Balance Mensual");

    this.data = JSON.parse(localStorage.getItem('data')!);
  }
  ngAfterViewInit(): void {
    this.getBalance();
  }

  ngOnInit() {
    this.setMonths();
    this.setYears();
  }


  setYears() {

    for (let index = 0; index <= 2; index++) {
      this.years.push({
        value: this.selectedYear - index,
        text: (this.selectedYear - index).toString()
      })
    }

  }

  changeMonthFilter(event: any) {
    this.selectedMonth = event.value
  }

  changeYearFilter(event: any) {
    this.selectedYear = event.value;
    this.setMonths();
  }

  setMonths() {
    this.months = [];
    this.selectedMonth = 0;
    for (let index = 0; index < this.MONTH_NAMES.length; index++) {
      let date = new Date(this.selectedYear, index, 1);
      let today = new Date();
      let nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);

      if (date <= today) {
        this.months.push({
          value: index,
          text: this.MONTH_NAMES[index]
        });
      }

    }

  }

  getBalance() {
    this.loading = true;
    this.fromDateRequest = new Date(this.selectedYear, this.selectedMonth, 1);
    this.service.getBalance(this.data.Client_number, this.selectedMonth + 1, this.selectedYear).subscribe({
      next: (resp: any) => {
        const cons = resp.map((item: any) => {

          return { ...item, fullCard: item.card.toString().padStart(5, "0") };
        });
        this.consumptions = cons;
        this.loading = false;
      },
      error: (erro: any) => {
        this.consumptions = [];

        this.loading = false;

      }
    })
  }

  months: any[] = [];
  years: any[] = [];

  downloadOptions = [{
    value: 1,
    text: 'XLS',
    action: (event: any) => this.generateReportConsumptions(),
  }, {
    value: 2,
    text: 'PDF',
    action: (event: any) => this.generateReportConsumptions(),
  }];
  headers: any[] = [
    { key: "date", textHeader: "Fecha", visible: true, type: "date" },
    { key: "identification", textHeader: "Identificación", visible: true, type: "string" },
    { key: "fullCard", textHeader: "Tarjeta", visible: true, type: "string" },
    { key: "limite", textHeader: "Limite", visible: true, type: "currency" },
    { key: "name", textHeader: "Nombre", visible: true, type: "string" },
    { key: "consumption", textHeader: "Consumos", visible: true, type: "currency" },
    { key: "diff", textHeader: "Diferencia", visible: true, type: "currency" },
    { key: "balance", textHeader: "Balance", visible: true, type: "currency" },



  ];

  download(id: string) {
    let url = '';
    let dateString = (this.selectedMonth + 1).toString().padStart(2, "0").substring(0, 2) + '/01/' + this.selectedYear.toString();
    if (id == "1") {
     
      url = this.reporterURL + 'Excel/MonederoXiga.aspx?rptName=balance&client=' + this.data.Client_number + '&Date=' + dateString
    }

    if (id == "2") {
    
      url = this.reporterURL + 'Pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Balance&client=' + this.data.Client_number + '&Date=' + dateString
    }

    window.open(url, "_blank");

  }

  generateReportConsumptions() {
    

  }
}
